import { createSlice } from '@reduxjs/toolkit'

const mainToCardSlice = createSlice({
  name: 'mainToCard',
  initialState: {
    reqTypeData: [],
    userData: [],
    groupData: [],
    requestData: [],
    buyerData: [],
    approvalRolesData: [],
    approvalStageData: [],
    approvalStageRoleData: [],
    approvalStageCardData: [],
    vendorData: [],
    rfqsData: [],
    bidsData: [],
    userInfo: [],
    evaluation: {},
    orderData: [],
    requestListData: [],
    bidsListData: [],
    selectedMaterialData: [],
    analysisData: [],
    analysisStructureData: [],
    analysisDimensionDataData: [],
    analysisCodeData: [],
    vendorRfqData: [],
    vendorCardHeaderData: {},
    attachmentCount: 0,
    attachmentMainCount: 0,
    attachmentInnerCount: 0,
    requestFilterData: {},
    excelImportData: [],
    reFetch: false,
    cardRequest: {},
    invoiceMain: [],
  },
  reducers: {
    updateReqTypeData: (state, action) => {
      state.reqTypeData = action.payload
    },
    updateUserData: (state, action) => {
      state.userData = action.payload
    },
    updateGroupData: (state, action) => {
      state.groupData = action.payload
    },
    updateRequestData: (state, action) => {
      state.requestData = action.payload
    },
    updateBuyerData: (state, action) => {
      state.buyerData = action.payload
    },
    updateApprovalRolesData: (state, action) => {
      state.approvalRolesData = action.payload
    },
    updateApprovalStageData: (state, action) => {
      state.approvalStageData = action.payload
    },
    updateApprovalStageRoleData: (state, action) => {
      state.approvalStageData = action.payload
    },
    updateApprovalStageCardData: (state, action) => {
      state.approvalStageCardData = action.payload
    },
    updateVendorData: (state, action) => {
      state.vendorData = action.payload
    },
    updateRFQSData: (state, action) => {
      state.rfqsData = action.payload
    },
    updateBIDsData: (state, action) => {
      state.bidsData = action.payload
    },
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload
    },
    updateEvaluation: (state, action) => {
      state.evaluation = action.payload
    },
    updateOrderData: (state, action) => {
      state.orderData = action.payload
    },
    updateRequestListData: (state, action) => {
      state.requestListData = action.payload
    },
    updateBidsListData: (state, action) => {
      state.bidsListData = action.payload
    },
    updateSelectedMaterialData: (state, action) => {
      state.selectedMaterialData = action.payload
    },
    updateAnalysisData: (state, action) => {
      state.analysisData = action.payload
    },
    updateVendorRfqData: (state, action) => {
      state.vendorRfqData = action.payload
    },
    updateVendorCardHeaderData: (state, action) => {
      state.vendorCardHeaderData = action.payload
    },
    updateAnalysisStructureData: (state, action) => {
      state.analysisStructureData = action.payload
    },
    updateAnalysisDimensionData: (state, action) => {
      state.analysisDimensionData = action.payload
    },
    updateAnalysisCodeData: (state, action) => {
      state.analysisCodeData = action.payload
    },
    updateAttachmentCount: (state, action) => {
      state.attachmentCount = action.payload
    },
    updateAttachmentMainCount: (state, action) => {
      state.attachmentMainCount = action.payload
    },
    updateAttachmentInnerCount: (state, action) => {
      state.attachmentInnerCount = action.payload
    },
    updateRequestFilterData: (state, action) => {
      state.requestFilterData = action.payload
    },
    updateExcelImportData: (state, action) => {
      state.excelImportData = action.payload
    },
    updateReFetch: (state, action) => {
      state.reFetch = action.payload
    },
    updateCardRequest: (state, action) => {
      state.cardRequest = action.payload
    },
    updateInvoiceMain: (state, action) => {
      state.invoiceMain = action.payload
    },
  },
})

export const {
  updateReqTypeData,
  updateUserData,
  updateGroupData,
  updateBuyerData,
  updateRequestData,
  updateApprovalRolesData,
  updateApprovalStageData,
  updateApprovalStageRoleData,
  updateApprovalStageCardData,
  updateVendorData,
  updateRFQSData,
  updateBIDsData,
  updateUserInfo,
  updateEvaluation,
  updateOrderData,
  updateRequestListData,
  updateBidsListData,
  updateSelectedMaterialData,
  updateAnalysisData,
  updateVendorRfqData,
  updateVendorCardHeaderData,
  updateAnalysisStructureData,
  updateAnalysisDimensionData,
  updateAnalysisCodeData,
  updateAttachmentCount,
  updateAttachmentMainCount,
  updateAttachmentInnerCount,
  updateRequestFilterData,
  updateExcelImportData,
  updateReFetch,
  updateCardRequest,
  updateInvoiceMain
} = mainToCardSlice.actions

export const mainToCardReducer = mainToCardSlice.reducer